import React from "react";
import { Reveal, Overline } from "@/components/Reveal";
import { GlowOrb } from "@/components/Decor";

export function PageHero({ overline, title, subtitle, image }) {
  return (
    <section className="relative overflow-hidden pt-36 pb-16 lg:pt-44 lg:pb-24">
      {image && (
        <div className="absolute inset-0 -z-20">
          <img src={image} alt={typeof title === "string" ? title : "Imperium Group"} className="h-full w-full object-cover opacity-15" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#090B0E]/80 via-[#090B0E]/90 to-[#090B0E]" />
        </div>
      )}
      <div className="absolute inset-0 -z-10 grid-bg" />
      <GlowOrb className="-left-32 -top-10" color="flame" size={460} />
      <GlowOrb className="-right-40 top-20" color="mint" size={320} />
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          {overline && <Overline>{overline}</Overline>}
          <h1 className="mt-4 max-w-4xl font-display text-4xl font-extrabold leading-[1.1] tracking-tight text-white sm:text-5xl lg:text-6xl">{title}</h1>
          {subtitle && <p className="mt-6 max-w-2xl text-lg leading-relaxed text-slate-300">{subtitle}</p>}
        </Reveal>
      </div>
    </section>
  );
}
